var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { useDebounce } from "use-debounce";
import { CircularProgress, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { useSearchPlaylists } from "frontend/src/domain/playlists";
export var PlaylistByTitleAutocomplete = function (_a) {
    var label = _a.label, onChange = _a.onChange;
    var _b = React.useState(false), isOpen = _b[0], setOpen = _b[1];
    var _c = React.useState(""), title = _c[0], setTitle = _c[1];
    var searchBy = useDebounce(title, 1000)[0];
    var _d = useSearchPlaylists({
        skip: 0,
        limit: 10,
        type: "any",
        title: searchBy,
        clientId: null,
    }), data = _d.data, isLoading = _d.isLoading;
    var getPlaylistLabel = function (playlist) {
        return playlist.type === "private"
            ? playlist.title + " (" + (playlist.clientLogin || "\u043A\u043B\u0438\u0435\u043D\u0442 #" + playlist.client.id) + ")"
            : playlist.title;
    };
    return (React.createElement(Autocomplete, { open: isOpen, onOpen: function () { return setOpen(true); }, onClose: function () { return setOpen(false); }, getOptionSelected: function (option, value) { return option.id === value.id; }, getOptionLabel: getPlaylistLabel, options: data ? data.playlists : [], loading: isLoading, loadingText: "Поиск...", noOptionsText: "Плейлисты не найдены", fullWidth: true, onInputChange: function (_, value) { return setTitle(value); }, onChange: function (_, playlist) {
            if (playlist) {
                onChange(playlist);
            }
        }, renderInput: function (params) { return (React.createElement(TextField, __assign({}, params, { label: label, InputProps: __assign(__assign({}, params.InputProps), { endAdornment: (React.createElement(React.Fragment, null,
                    isLoading && React.createElement(CircularProgress, { color: "inherit", size: 20 }),
                    params.InputProps.endAdornment)) }) }))); } }));
};
